import { bl_alg_cc_project_drive_link_RowClass, bl_alg_cc_project_drive_link_RowInterface } from "../../../../dbschema/bl_alg_cc_project_drive_link.model";
import {BaseContainerModel} from "../../../base-container.model";

export class ProjectDriveContainerModel extends BaseContainerModel {
  bl_alg_cc_project_drive_link: bl_alg_cc_project_drive_link_RowInterface = new bl_alg_cc_project_drive_link_RowClass();
}
